import React from 'react';
import { vFParamsPropShape } from './data-structure/v-f-proptypes';
import 'AppSrc/core/style/components/form/form-base-components/v-f-paragraph.css';


const VFParagraph = React.memo(({
  vFParams,
}) => {
  const {
    paragraph,
    fieldId,
  } = vFParams;

  const pcrStatusReason = window.localStorage.getItem('statusReason');
  return (
    ((fieldId === 'paragraph-based-on' || fieldId === 'paragraph-please-complete') && (pcrStatusReason === '6200' || pcrStatusReason === 'Unsuccessful')) ? <p className="v-f-paragraph-readOnly">{paragraph}</p> : <p className="v-f-paragraph">{paragraph}</p>
  );
});

VFParagraph.propTypes = {
  vFParams: vFParamsPropShape,
};

const VF_PARAGRAPH = 'v-f-paragraph';

export {
  VF_PARAGRAPH,
  VFParagraph,
};
